import React, { useState } from "react";
import TopNav from '../LandingPage/TopNav/TopNav';
import { Link } from "react-router-dom";
import { inject, observer } from "mobx-react";
import { validateEmail } from "../shared/ValidateEmail";

import styles from "./Login.css";


const Login = inject("authStore", "userStore")(observer((props) => {
	const [email, setEmail] = useState("");
	const [errorMessage, setErrorMessage] = useState("");
	const [code, setCode] = useState("");
	const [countdown, setCountdown] = useState(100);
	const [isCounting, setIsCounting] = useState(false);
	const [disabled, setDisabled] = useState(false);

	const startCountdown = () => {
		setIsCounting(true);

		setDisabled(true);
		const countdownTimer = setInterval(() => {
			setCountdown((prevCountdown) => {
				if (prevCountdown > 0) {
					return prevCountdown - 1;
				} else {
					setIsCounting(false);
					setDisabled(false);
					clearInterval(countdownTimer);
					return prevCountdown;
				}
			});
		}, 1000);
	};

	const handleCodeChange = e => {
		setCode(e.target.value);
	}

	const sendCode = e => {
		startCountdown();
		props.authStore.validateEmail(email).then(() => {
		})
	}

	const handleEmailChange = e => {
		setEmail(e.target.value);
		setErrorMessage("");
	};

	const handleSubmitForm = e => {
		e.preventDefault();

		if (email === "") {
			setErrorMessage("Email is empty");
			return;
		}

		if (validateEmail(email)) {
			setErrorMessage("Please correct email");
			return;
		}

		if (code === "") {
			setErrorMessage("code is empty");
			return;
		}
		setErrorMessage("");
		props.authStore.login(email, code).then(() => {
			if (props.authStore.errorMessage === "") {
				const prevLocation = localStorage.getItem('prevLocation') || '/';
				localStorage.removeItem('prevLocation');
				props.history.push(prevLocation);
			} else {
				setErrorMessage(props.authStore.errorMessage);
			}
		})
	};

	return (
		<div className="page">
			<TopNav isLoggedIn={!!props.userStore.currentUser} />
			<form className="login-form" onSubmit={handleSubmitForm}>
				<div className="login-text">Sign In</div>
				<input
					className="login-input"
					type="email"
					placeholder="Email"
					onChange={handleEmailChange}
				/>
				<div className='row-container'>
					<input
						className="validation-input"
						placeholder="Code"
						onChange={handleCodeChange}
					/>
					<button
						className="validation-button"
						type="submit"
						onClick={sendCode}
						disabled={disabled}
					>
						{isCounting ? `Send code in ${countdown}s` : 'Send code'}
					</button>
				</div>
				<div style={{ "fontSize": "small" }}>By signing in you agree <Link to="terms">terms of use</Link> and <Link to="privacy">privacy policy</Link></div>
				<button
					className="login-button"
					type="submit"
				>
					Sign in
				</button>
				<div className="error-message">{errorMessage}</div>
			</form>
		</div>
	);
}));

export default Login;